import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-olive-dark text-ivory/80 py-16 border-t border-gold/20">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="font-serif text-2xl tracking-[0.2em] text-gold mb-8">PADUA WEDDINGS</h2>
        
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-12 font-sans font-light text-sm tracking-wide">
          <a href="https://paduaweddings.com" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">
            paduaweddings.com
          </a>
          <span className="hidden md:block w-1 h-1 bg-gold/50 rounded-full"></span>
          <a href="mailto:info@paduaweddings.com" className="hover:text-gold transition-colors">
            info@paduaweddings.com
          </a>
          <span className="hidden md:block w-1 h-1 bg-gold/50 rounded-full"></span>
          <a href="tel:9096241241" className="hover:text-gold transition-colors">
            909.624.1241
          </a>
        </div>
        
        <div className="mt-12 text-xs font-sans font-light opacity-50">
          &copy; {new Date().getFullYear()} Padua Weddings. All rights reserved.
        </div>
      </div>
    </footer>
  );
}